const CUSTOM_ELEMENT_ID = "content-usp";

class ContentUsp extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
  }
}

if (!customElements.get(CUSTOM_ELEMENT_ID)) {
  customElements.define(CUSTOM_ELEMENT_ID, ContentUsp);
}
